import React from 'react';
import CustomerLayout from '../components/CustomerLayout';
import '../App.css';

export default function Marketplace() {
    const features = [
        { title: 'Domain Registration', description: 'Register and manage domain names', icon: '🌐' },
        { title: 'Office 365 Licenses', description: 'Purchase Microsoft 365 subscriptions', icon: '📧' },
        { title: 'WordPress Hosting', description: 'Managed WordPress hosting plans', icon: '🌟' },
        { title: 'Email Hosting', description: 'Professional email hosting', icon: '✉️' },
        { title: 'SSL Certificates', description: 'Secure your websites', icon: '🔒' },
        { title: 'Custom Services', description: 'Request custom solutions', icon: '⚙️' }
    ];

    return (
        <CustomerLayout>
            <div style={{ maxWidth: '1200px' }}>
                <div style={{ textAlign: 'center', marginBottom: '50px' }}>
                    <h1 style={{ fontSize: '48px', marginBottom: '20px' }}>Service Marketplace</h1>
                    <div
                        style={{
                            display: 'inline-block',
                            padding: '10px 30px',
                            background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                            color: 'white',
                            borderRadius: '25px',
                            fontSize: '18px',
                            fontWeight: 'bold',
                            marginBottom: '20px'
                        }}
                    >
                        Coming Soon
                    </div>
                    <p style={{ fontSize: '20px', color: '#666', maxWidth: '600px', margin: '0 auto' }}>
                        Purchase services, manage subscriptions, and request custom solutions - all in one place
                    </p>
                </div>

                <div
                    style={{
                        display: 'grid',
                        gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))',
                        gap: '30px',
                        marginBottom: '50px'
                    }}
                >
                    {features.map((feature, index) => (
                        <div className="card" key={index} style={{ textAlign: 'center', padding: '40px 30px' }}>
                            <div style={{ fontSize: '64px', marginBottom: '20px' }}>{feature.icon}</div>
                            <h3 style={{ marginBottom: '10px' }}>{feature.title}</h3>
                            <p style={{ color: '#666' }}>{feature.description}</p>
                        </div>
                    ))}
                </div>

                <div className="card" style={{ textAlign: 'center', padding: '40px' }}>
                    <h2 style={{ marginBottom: '20px' }}>Need Something Now?</h2>
                    <p style={{ color: '#666', marginBottom: '30px' }}>
                        In the meantime, you can request services by creating a support ticket
                    </p>
                    <div style={{ display: 'flex', gap: '15px', justifyContent: 'center' }}>
                        <button
                            className="btn btn-primary"
                            onClick={() => window.location.href = '/tickets'}
                            style={{ padding: '15px 40px', fontSize: '16px' }}
                        >
                            Create Support Ticket
                        </button>
                        <a
                            href={`mailto:${process.env.REACT_APP_SUPPORT_EMAIL}`}
                            style={{ textDecoration: 'none' }}
                        >
                            <button
                                className="btn btn-secondary"
                                style={{ padding: '15px 40px', fontSize: '16px' }}
                            >
                                Email Us
                            </button>
                        </a>
                    </div>
                </div>

                <div style={{ marginTop: '50px', textAlign: 'center', color: '#999' }}>
                    <p>The marketplace will launch soon with:</p>
                    <ul style={{ listStyle: 'none', padding: 0, marginTop: '15px' }}>
                        <li>✓ One-click service purchasing</li>
                        <li>✓ Secure online payments</li>
                        <li>✓ Instant provisioning</li>
                        <li>✓ Subscription management</li>
                        <li>✓ Usage tracking and billing</li>
                    </ul>
                </div>
            </div>
        </CustomerLayout>
    );
}
